/**
 * Theme note: In layout/theme.liquid use {{ 'homepage.js' | asset_url | script_tag: defer: 'defer' }}
 * Re-bind after section editor events: document.addEventListener('shopify:section:load', initHomepage);
 */
document.addEventListener('DOMContentLoaded', function initHomepage() {
  'use strict';

  const legacyResearchPaths = new Set([
    '/pages/sanddune_researchnew',
    '/pages/sanddune-researchnew',
    '/pages/reserch'
  ]);

  if (legacyResearchPaths.has(window.location.pathname)) {
    window.location.replace(`/pages/research${window.location.search || ''}${window.location.hash || ''}`);
    return;
  }

  const shopTrigger = document.getElementById('shop-trigger');
  const megaMenu = document.getElementById('shop-dropdown');
  const overlay = document.getElementById('overlay');
  const headerWrapper = document.querySelector('.header-wrapper');
  const mobileMenuOpen = document.getElementById('mobile-menu-open');
  const navEl = document.querySelector('.nav');
  const accountTrigger = document.getElementById('nav-account-trigger');
  const cartTrigger = document.getElementById('nav-cart-trigger');
  const accountModal = document.getElementById('account-modal');
  const cartDrawer = document.getElementById('cart-drawer');
  const searchTrigger = document.getElementById('nav-search-trigger');
  const searchPopup = document.getElementById('search-popup');
  const searchPopupClose = document.getElementById('search-popup-close');
  const searchPopupBackdrop = document.getElementById('search-popup-backdrop');
  const searchInput = document.getElementById('search-popup-input');
  const searchClear = document.getElementById('search-popup-clear');
  const searchViewAll = document.getElementById('search-view-all');
  const searchStateidle = document.getElementById('search-state-idle');
  const searchStateLoading = document.getElementById('search-state-loading');
  const searchStateResults = document.getElementById('search-state-results');
  const searchStateEmpty = document.getElementById('search-state-empty');
  const searchResultsMeta = document.getElementById('search-results-meta');
  const searchResultsList = document.getElementById('search-results-list');

  function anyDrawerOpen() {
    return accountModal?.classList.contains('is-open') || cartDrawer?.classList.contains('is-open');
  }

  function syncGlobalOverlay() {
    if (!overlay) return;
    const menuOpen = Boolean(megaMenu && megaMenu.classList.contains('open'));
    overlay.classList.toggle('open', menuOpen || anyDrawerOpen());
  }

  function openPanel(panel, trigger) {
    if (!panel || !trigger) return;
    closeMenu();
    closeMobileNavPanel();
    closeDrawers();
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    syncGlobalOverlay();
  }

  function closeDrawers() {
    if (accountModal) {
      accountModal.classList.remove('is-open');
      accountModal.setAttribute('aria-hidden', 'true');
    }
    if (cartDrawer) {
      cartDrawer.classList.remove('is-open');
      cartDrawer.setAttribute('aria-hidden', 'true');
    }
    if (accountTrigger) accountTrigger.setAttribute('aria-expanded', 'false');
    if (cartTrigger) cartTrigger.setAttribute('aria-expanded', 'false');
  }

  function updateHeaderOnScroll() {
    if (!headerWrapper) return;
    headerWrapper.classList.toggle('is-scrolled', window.scrollY > 80);
  }

  updateHeaderOnScroll();
  window.addEventListener('scroll', updateHeaderOnScroll, { passive: true });

  function closeMobileNavPanel() {
    if (!navEl || !navEl.classList.contains('nav-mobile-open')) return;
    navEl.classList.remove('nav-mobile-open');
    if (mobileMenuOpen) mobileMenuOpen.setAttribute('aria-expanded', 'false');
  }

  function openMenu() {
    closeMobileNavPanel();
    closeDrawers();
    if (!megaMenu || !shopTrigger) return;
    megaMenu.classList.add('open');
    shopTrigger.classList.add('active');
    syncGlobalOverlay();
  }

  function closeMenu() {
    if (!megaMenu || !shopTrigger) return;
    megaMenu.classList.remove('open');
    shopTrigger.classList.remove('active');
    syncGlobalOverlay();
  }

  shopTrigger?.addEventListener('click', function (e) {
    e.preventDefault();
    closeDrawers();
    if (!megaMenu) return;
    megaMenu.classList.contains('open') ? closeMenu() : openMenu();
  });

  accountTrigger?.addEventListener('click', function (event) {
    event.preventDefault();
    if (!accountModal || !accountTrigger) return;
    if (accountModal.classList.contains('is-open')) {
      closeDrawers();
      syncGlobalOverlay();
      return;
    }
    openPanel(accountModal, accountTrigger);
  });

  cartTrigger?.addEventListener('click', function (event) {
    event.preventDefault();
    if (!cartDrawer || !cartTrigger) return;
    if (cartDrawer.classList.contains('is-open')) {
      closeDrawers();
      syncGlobalOverlay();
      return;
    }
    openPanel(cartDrawer, cartTrigger);
  });

  document.querySelectorAll('[data-close-drawer]').forEach(btn => {
    btn.addEventListener('click', function () {
      closeDrawers();
      syncGlobalOverlay();
    });
  });

  document.querySelectorAll('#cart-drawer').forEach(drawer => {
    drawer.addEventListener('click', function (event) {
      event.stopPropagation();
    });
  });

  accountModal?.querySelector('.account-modal__panel')?.addEventListener('click', function (event) {
    event.stopPropagation();
  });

  document.addEventListener('click', function (event) {
    if (!anyDrawerOpen()) return;
    const clickedInsideCart = event.target.closest('#cart-drawer');
    const clickedInsideAccount = event.target.closest('.account-modal__panel');
    const clickedAccountTrigger = event.target.closest('#nav-account-trigger');
    const clickedCartTrigger = event.target.closest('#nav-cart-trigger');

    if (accountModal?.classList.contains('is-open') && !clickedInsideAccount && !clickedAccountTrigger) {
      closeDrawers();
      syncGlobalOverlay();
      return;
    }

    if (cartDrawer?.classList.contains('is-open') && !clickedInsideCart && !clickedCartTrigger) {
      closeDrawers();
      syncGlobalOverlay();
    }
  });

  mobileMenuOpen?.addEventListener('click', function () {
    if (!navEl) return;
    closeDrawers();
    closeMenu();
    const open = navEl.classList.toggle('nav-mobile-open');
    mobileMenuOpen.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  overlay?.addEventListener('click', function () {
    closeMenu();
    closeMobileNavPanel();
    closeDrawers();
    syncGlobalOverlay();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMenu();
      closeMobileNavPanel();
      closeDrawers();
      syncGlobalOverlay();
    }
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth > 768) closeMobileNavPanel();
  });

  document.querySelectorAll('.filter-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  const collectionTypeFilter = document.getElementById('collection-type-filter');
  const collectionSort = document.getElementById('collection-sort');
  const collectionCount = document.getElementById('collection-count');
  const collectionGrid = document.querySelector('[data-section-type="collection-grid"] .products-grid');

  function applyCollectionView() {
    if (!collectionGrid) return;
    const cards = Array.from(collectionGrid.querySelectorAll('.product-card'));
    const activeType = collectionTypeFilter?.value || 'all';

    cards.forEach(card => {
      const type = card.dataset.productType || '';
      const visible = activeType === 'all' || type === activeType;
      card.style.display = visible ? '' : 'none';
    });

    if (collectionSort && collectionSort.value !== 'featured') {
      const visibleCards = cards.filter(card => card.style.display !== 'none');
      visibleCards.sort((a, b) => {
        const aPrice = parseInt(a.dataset.productPrice || '0', 10);
        const bPrice = parseInt(b.dataset.productPrice || '0', 10);
        const aTitle = (a.dataset.productTitle || '').toLowerCase();
        const bTitle = (b.dataset.productTitle || '').toLowerCase();

        switch (collectionSort.value) {
          case 'price-asc':
            return aPrice - bPrice;
          case 'price-desc':
            return bPrice - aPrice;
          case 'title-asc':
            return aTitle.localeCompare(bTitle);
          case 'title-desc':
            return bTitle.localeCompare(aTitle);
          default:
            return 0;
        }
      });

      visibleCards.forEach(card => collectionGrid.appendChild(card));
    }

    if (collectionCount) {
      const shown = cards.filter(card => card.style.display !== 'none').length;
      collectionCount.textContent = `${shown} instruments`;
    }
  }

  collectionTypeFilter?.addEventListener('change', applyCollectionView);
  collectionSort?.addEventListener('change', applyCollectionView);
  applyCollectionView();

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatCartMoney(cents, currency) {
    const amount = (Number(cents) || 0) / 100;
    const code = currency || 'INR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
        style: 'currency',
        currency: code
      }).format(amount);
    } catch (_error) {
      return amount.toFixed(2);
    }
  }

  async function fetchCartState() {
    const response = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('cart_fetch_failed');
    return response.json();
  }

  function getCartBrowseUrl() {
    const browseUrl = cartDrawer?.dataset.browseUrl || '';
    if (!browseUrl || browseUrl === 'undefined' || browseUrl.includes('undefined')) {
      return '/collections/all';
    }
    return browseUrl;
  }

  function applyCartPageState(cart, options = {}) {
    const { removedBtn } = options;
    const subtotalValue = document.querySelector('.cart-summary__subtotal span:last-child');
    if (subtotalValue) {
      subtotalValue.textContent = formatCartMoney(cart.total_price, cart.currency);
    }

    const countBadge = document.querySelector('.nav-cart-count');
    if (countBadge) countBadge.textContent = cart.item_count;

    if (cart.item_count === 0) {
      const cartShell = document.querySelector('.cart-page.collection-shell');
      if (cartShell) {
        cartShell.innerHTML = `
          <div class="cart-page__header">
            <p class="section-label">Shopping cart</p>
            <h1 class="section-title">Your cart</h1>
          </div>
          <div class="cart-empty">
            <p class="cart-empty__text">Your cart is currently empty.</p>
            <a href="${getCartBrowseUrl()}" class="btn-primary cart-empty__btn">Browse instruments →</a>
          </div>
        `;
      }
      return;
    }

    if (removedBtn) {
      removedBtn.closest('.cart-table__row')?.remove();
    }

    const rows = document.querySelectorAll('.cart-table__row');
    cart.items.forEach((item, index) => {
      const row = rows[index];
      if (!row) return;

      const input = row.querySelector('input[name="updates[]"]');
      const lineTotal = row.querySelector('.cart-table__total');
      const qtyWrapper = row.querySelector('[data-cart-qty]');
      const removeBtn = row.querySelector('[data-cart-remove]');
      const lineNumber = String(index + 1);

      if (input) input.value = item.quantity;
      if (lineTotal) lineTotal.textContent = formatCartMoney(item.final_line_price, cart.currency);
      if (qtyWrapper) qtyWrapper.dataset.line = lineNumber;
      if (removeBtn) removeBtn.dataset.line = lineNumber;
    });
  }

  async function updateCartLine(line, quantity, pageOptions = {}) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ line, quantity })
    });

    if (!response.ok) throw new Error('cart_change_failed');

    const cart = await response.json();
    renderCartDrawer(cart);

    if (document.querySelector('.cart-page')) {
      applyCartPageState(cart, pageOptions);
    }

    return cart;
  }

  async function removeCartLine(line, triggerBtn) {
    return updateCartLine(line, 0, { removedBtn: triggerBtn });
  }

  function renderCartDrawer(cart) {
    if (!cartDrawer) return;

    const titleEl = cartDrawer.querySelector('.nav-drawer-title');
    const bodyEl = cartDrawer.querySelector('.nav-drawer-body');
    const countBadge = document.querySelector('.nav-cart-count');
    const baseTitle = titleEl?.dataset.baseTitle || 'Your cart';

    if (countBadge) countBadge.textContent = cart.item_count;
    if (titleEl) titleEl.textContent = `${baseTitle} (${cart.item_count})`;
    if (!bodyEl) return;

    if (!cart.item_count) {
      bodyEl.innerHTML = `
        <p class="drawer-empty">${escapeHtml(cartDrawer.dataset.emptyText || 'Your cart is empty.')}</p>
        <a href="${getCartBrowseUrl()}" class="drawer-btn">${escapeHtml(cartDrawer.dataset.browseLabel || 'Browse instruments')}</a>
      `;
      return;
    }

    const itemsHtml = cart.items.slice(0, 4).map((item, index) => `
      <div class="drawer-cart-item">
        ${item.image ? `<img src="${escapeHtml(item.image)}" alt="" class="drawer-cart-image" loading="lazy" width="68" height="68">` : ''}
        <div class="drawer-cart-meta">
          <p class="drawer-cart-name">${escapeHtml(item.product_title)}</p>
          <p class="drawer-cart-price">${formatCartMoney(item.final_line_price, cart.currency)}</p>
          <button type="button" class="drawer-cart-remove" data-drawer-cart-remove data-line="${index + 1}"><svg class="icon-trash" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M10 11v6"/><path d="M14 11v6"/></svg> ${escapeHtml(cartDrawer.dataset.removeLabel || 'Remove')}</button>
        </div>
      </div>
    `).join('');

    bodyEl.innerHTML = `
      ${itemsHtml}
      <a href="/cart" class="drawer-btn drawer-btn-secondary">${escapeHtml(cartDrawer.dataset.viewLabel || 'View cart')}</a>
      <a href="/cart" class="drawer-btn">${escapeHtml(cartDrawer.dataset.checkoutLabel || 'Checkout')}</a>
    `;
  }

  function bindCartDrawerActions() {
    if (!cartDrawer || cartDrawer.dataset.drawerActionsBound === 'true') return;
    cartDrawer.dataset.drawerActionsBound = 'true';

    cartDrawer.addEventListener('click', async event => {
      const btn = event.target.closest('[data-drawer-cart-remove]');
      if (!btn) return;

      event.preventDefault();

      const line = parseInt(btn.dataset.line, 10);
      if (!line) return;

      const originalLabel = btn.textContent.trim();
      btn.disabled = true;

      try {
        await removeCartLine(line, btn);
      } catch (_error) {
        btn.disabled = false;
        btn.textContent = originalLabel;
      }
    });
  }

  async function refreshCartUI(cartState) {
    const cart = cartState || await fetchCartState();
    renderCartDrawer(cart);
    return cart;
  }

  function openCartDrawerPanel() {
    if (!cartDrawer || !cartTrigger) return;
    openPanel(cartDrawer, cartTrigger);
  }

  async function addItemsToCart(items) {
    const payload = (items || [])
      .filter(item => item && item.id)
      .map(item => ({
        id: Number(item.id),
        quantity: Math.max(1, parseInt(item.quantity, 10) || 1)
      }));

    if (!payload.length) return false;

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload.length === 1 ? payload[0] : { items: payload })
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.description || 'add_failed');
    }

    await refreshCartUI();
    return true;
  }

  async function addVariantToCart(variantId, quantity = 1) {
    if (!variantId) return false;
    return addItemsToCart([{ id: variantId, quantity }]);
  }

  function getSelectedStandAddonVariantId() {
    const btn = document.querySelector('[data-stand-addon-btn].added');
    const variantId = btn?.dataset.variantId;
    return variantId || null;
  }

  function bindCartAddForms() {
    document.querySelectorAll('form[action*="/cart/add"], form.product-form').forEach(form => {
      if (form.dataset.cartAjaxBound === 'true') return;
      form.dataset.cartAjaxBound = 'true';

      form.addEventListener('submit', async event => {
        event.preventDefault();

        const formData = new FormData(form);
        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity') || '1', 10);
        if (!variantId) return;

        const submitBtn = form.querySelector(
          '[type="submit"][name="add"], [type="submit"].product-action-btn--primary, [type="submit"].add-btn, [type="submit"].rel-btn-add'
        );
        const originalLabel = submitBtn?.textContent;

        if (submitBtn) submitBtn.disabled = true;

        try {
          const items = [{ id: variantId, quantity }];
          const standVariantId = getSelectedStandAddonVariantId();
          if (standVariantId) items.push({ id: standVariantId, quantity: 1 });
          await addItemsToCart(items);
          openCartDrawerPanel();
        } catch (_error) {
          if (submitBtn && originalLabel) submitBtn.textContent = originalLabel;
        } finally {
          if (submitBtn) {
            submitBtn.disabled = false;
            if (originalLabel) submitBtn.textContent = originalLabel;
          }
        }
      });
    });
  }

  function initCartPageQty() {
    document.querySelectorAll('[data-cart-qty]').forEach(wrapper => {
      if (wrapper.dataset.cartQtyBound === 'true') return;
      wrapper.dataset.cartQtyBound = 'true';

      const input = wrapper.querySelector('input[name="updates[]"]');
      const minus = wrapper.querySelector('[data-qty-minus]');
      const plus = wrapper.querySelector('[data-qty-plus]');
      if (!input || !minus || !plus) return;

      const syncQuantity = async (nextQuantity) => {
        const line = parseInt(wrapper.dataset.line, 10);
        const quantity = Math.max(1, parseInt(nextQuantity, 10) || 1);
        if (!line || wrapper.dataset.qtyUpdating === 'true') return;

        input.value = quantity;
        wrapper.dataset.qtyUpdating = 'true';
        minus.disabled = true;
        plus.disabled = true;

        try {
          await updateCartLine(line, quantity);
        } catch (_error) {
          const cart = await fetchCartState().catch(() => null);
          if (cart) applyCartPageState(cart);
        } finally {
          wrapper.dataset.qtyUpdating = 'false';
          minus.disabled = false;
          plus.disabled = false;
        }
      };

      minus.addEventListener('click', () => {
        const current = parseInt(input.value, 10) || 1;
        if (current > 1) syncQuantity(current - 1);
      });

      plus.addEventListener('click', () => {
        const current = parseInt(input.value, 10) || 1;
        syncQuantity(current + 1);
      });

      input.addEventListener('change', () => {
        syncQuantity(input.value);
      });
    });
  }

  function initCartPageRemove() {
    document.querySelectorAll('[data-cart-remove]').forEach(btn => {
      if (btn.dataset.cartRemoveBound === 'true') return;
      btn.dataset.cartRemoveBound = 'true';

      btn.addEventListener('click', async () => {
        const line = parseInt(btn.dataset.line, 10);
        if (!line) return;

        const originalLabel = btn.textContent.trim();
        btn.disabled = true;

        try {
          await removeCartLine(line, btn);
        } catch (_error) {
          btn.disabled = false;
          btn.textContent = originalLabel;
        }
      });
    });
  }

  bindCartAddForms();
  bindCartDrawerActions();
  document.addEventListener('shopify:section:load', bindCartAddForms);
  initCartPageQty();
  initCartPageRemove();
  document.addEventListener('shopify:section:load', initCartPageQty);
  document.addEventListener('shopify:section:load', initCartPageRemove);

  document.querySelectorAll('[data-collection-add]').forEach(btn => {
    btn.addEventListener('click', async event => {
      event.preventDefault();
      event.stopPropagation();

      const variantId = btn.dataset.variantId;
      if (!variantId || btn.disabled) return;

      const originalLabel = btn.textContent;
      btn.disabled = true;

      try {
        const added = await addVariantToCart(variantId, 1);
        if (added) openCartDrawerPanel();
      } catch (_error) {
      } finally {
        btn.disabled = false;
        btn.textContent = originalLabel;
      }
    });
  });

  document.querySelectorAll('[data-collection-buy]').forEach(btn => {
    btn.addEventListener('click', async event => {
      event.preventDefault();
      event.stopPropagation();

      const variantId = btn.dataset.variantId;
      if (!variantId || btn.disabled) return;

      const originalLabel = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Processing...';

      try {
        const added = await addVariantToCart(variantId, 1);
        if (added) {
          window.location.href = '/checkout';
          return;
        }
      } catch (_error) {
      }

      btn.disabled = false;
      btn.textContent = originalLabel;
    });
  });

  const testimonialSlider = document.getElementById('testimonial-slider');
  const testimonialPrev = document.querySelector('[data-testi-prev]');
  const testimonialNext = document.querySelector('[data-testi-next]');

  function scrollTestimonials(direction) {
    if (!testimonialSlider) return;
    const card = testimonialSlider.querySelector('.testi-card');
    const scrollAmount = card ? card.offsetWidth + 24 : 360;
    testimonialSlider.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
  }

  testimonialPrev?.addEventListener('click', () => scrollTestimonials(-1));
  testimonialNext?.addEventListener('click', () => scrollTestimonials(1));

  const faqItems = document.querySelectorAll('.faq-item');

  function setFaqHeight(item) {
    const panel = item.querySelector('.faq-a');
    const inner = item.querySelector('.faq-a-inner');
    if (!panel || !inner) return;
    panel.style.maxHeight = item.classList.contains('open') ? `${inner.scrollHeight}px` : '0px';
  }

  faqItems.forEach(item => {
    const trigger = item.querySelector('.faq-q');
    setFaqHeight(item);

    trigger?.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');
      faqItems.forEach(otherItem => {
        otherItem.classList.remove('open');
        otherItem.querySelector('.faq-q')?.setAttribute('aria-expanded', 'false');
        setFaqHeight(otherItem);
      });

      if (!isOpen) {
        item.classList.add('open');
        trigger?.setAttribute('aria-expanded', 'true');
        setFaqHeight(item);
      }
    });
  });

  window.addEventListener('resize', () => {
    faqItems.forEach(setFaqHeight);
  });

  function normalizeLegacyInternalLinks() {
    const routeMap = {
      'about_us': '/pages/about',
      'sanddune_researchnew': '/pages/research',
      'contact_us': '/pages/contact',
      'privacy_policy': '/policies/privacy-policy',
      'account': '/account',
      'all_products': '/collections/all',
      'product': '/collections/all',
      'mindfulnessbell-4': '/collections/all'
    };

    document.querySelectorAll('a[href]').forEach(anchor => {
      const href = anchor.getAttribute('href');
      if (!href || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('#')) return;

      let url;
      try {
        url = new URL(href, window.location.origin);
      } catch (_error) {
        return;
      }

      if (url.origin !== window.location.origin) return;

      const htmlMatch = url.pathname.match(/\/([^\/]+)\.html$/i);
      if (!htmlMatch) return;

      const slug = htmlMatch[1].toLowerCase();
      const mappedPath = routeMap[slug] || `/products/${slug}`;
      const finalHref = `${mappedPath}${url.search || ''}${url.hash || ''}`;
      anchor.setAttribute('href', finalHref);
    });
  }

  normalizeLegacyInternalLinks();

  // Journey tabs — About page
  const journeyTabs = document.querySelectorAll('.journey-tab');
  const journeyProgress = document.getElementById('journey-progress');
  journeyTabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      journeyTabs.forEach(t => t.classList.remove('active'));
      document.querySelectorAll('.journey-panel').forEach(p => p.classList.remove('active'));
      tab.classList.add('active');
      document.getElementById(tab.getAttribute('data-target')).classList.add('active');
      if (journeyProgress) {
        journeyProgress.style.width = (index / (journeyTabs.length - 1)) * 100 + '%';
      }
    });
  });

  initResearchBridge();
  initVideoTestimonials();
  initTrackOrderForm();

  // ── PRODUCT PAGE ────────────────────────────────────────────────────────

  initProductGallery();
  initProductReviewSliders();
  initProductReviewForm();
  window.addEventListener('load', initProductReviewSliders, { once: true });

  // Variant bundle card selector
  const variantCards = document.querySelectorAll('.bundle-card');
  const variantIdInput = document.getElementById('variant-id');
  const mainPriceEl = document.getElementById('main-price');
  const addToCartBtn = document.getElementById('add-to-cart-btn');

  const buyNowBtn = document.querySelector('[data-buy-now]');

  variantCards.forEach(card => {
    card.addEventListener('click', function () {
      variantCards.forEach(c => {
        c.classList.remove('selected');
        c.setAttribute('aria-pressed', 'false');
      });
      this.classList.add('selected');
      this.setAttribute('aria-pressed', 'true');

      const variantId = this.dataset.variantId;
      const price = this.dataset.price;
      const available = this.dataset.available === 'true';
      const imageUrl = this.getAttribute('data-image-url');
      const imageAlt = this.getAttribute('data-image-alt');

      if (variantIdInput) variantIdInput.value = variantId;
      if (mainPriceEl) mainPriceEl.textContent = price;

      if (addToCartBtn) {
        addToCartBtn.disabled = !available;
        addToCartBtn.textContent = available ? 'Add to cart — ' + price : 'Sold out';
      }
      if (buyNowBtn) buyNowBtn.disabled = !available;

      if (imageUrl) {
        const mainImg = document.getElementById('main-product-img');
        setMainProductImage(mainImg, imageUrl, imageAlt);
        const strip = document.querySelector('[data-section-type="product-information"] .thumbnail-strip');
        if (strip) {
          strip.querySelectorAll('.thumb').forEach(t => t.classList.remove('active'));
        }
      }

      const variantTitle = this.dataset.variantTitle;
      updateVariantIncludes(variantTitle);
    });
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.click();
      }
    });
  });

  // Product page quantity stepper
  const qtyMinus = document.getElementById('qty-minus');
  const qtyPlus  = document.getElementById('qty-plus');
  const qtyEl    = document.getElementById('qty');

  if (qtyEl && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', () => {
      const current = parseInt(qtyEl.textContent || qtyEl.value || '1');
      if (current > 1) {
        if (qtyEl.tagName === 'INPUT') qtyEl.value = current - 1;
        else qtyEl.textContent = current - 1;
        const hiddenQty = document.getElementById('cart-quantity');
        if (hiddenQty) hiddenQty.value = qtyEl.textContent || qtyEl.value || '1';
      }
    });
    qtyPlus.addEventListener('click', () => {
      const current = parseInt(qtyEl.textContent || qtyEl.value || '1');
      if (qtyEl.tagName === 'INPUT') qtyEl.value = current + 1;
      else qtyEl.textContent = current + 1;
      const hiddenQty = document.getElementById('cart-quantity');
      if (hiddenQty) hiddenQty.value = qtyEl.textContent || qtyEl.value || '1';
    });

    qtyEl.addEventListener('input', () => {
      const hiddenQty = document.getElementById('cart-quantity');
      if (hiddenQty) hiddenQty.value = qtyEl.textContent || qtyEl.value || '1';
    });
  }

  document.querySelectorAll('[data-stand-addon-btn]').forEach(btn => {
    if (!btn.dataset.defaultLabel) {
      btn.dataset.defaultLabel = btn.textContent.trim();
    }

    btn.addEventListener('click', () => {
      if (!btn.dataset.variantId) return;

      const added = btn.classList.toggle('added');
      btn.setAttribute('aria-pressed', added ? 'true' : 'false');
      const addedLabel = btn.dataset.addedLabel;
      const defaultLabel = btn.dataset.defaultLabel;
      if (added && addedLabel) btn.textContent = addedLabel;
      else if (defaultLabel) btn.textContent = defaultLabel;
    });
  });

  const wishlistButtons = document.querySelectorAll('[data-wishlist-toggle]');
  const wishlistKey = 'mdtWishlist';
  const safeGetWishlist = () => {
    try {
      return JSON.parse(localStorage.getItem(wishlistKey) || '[]');
    } catch (_error) {
      return [];
    }
  };

  function syncWishlistButtons() {
    const wishlist = safeGetWishlist();
    wishlistButtons.forEach(btn => {
      const handle = btn.dataset.productHandle;
      const active = handle && wishlist.includes(handle);
      btn.classList.toggle('is-active', Boolean(active));
      btn.textContent = active ? 'Wishlisted' : 'Add to Wishlist';
    });
  }

  wishlistButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const handle = btn.dataset.productHandle;
      if (!handle) return;
      const wishlist = safeGetWishlist();
      const index = wishlist.indexOf(handle);
      if (index >= 0) wishlist.splice(index, 1);
      else wishlist.push(handle);
      localStorage.setItem(wishlistKey, JSON.stringify(wishlist));
      syncWishlistButtons();
    });
  });
  syncWishlistButtons();

  document.querySelectorAll('[data-buy-now]').forEach(btn => {
    btn.addEventListener('click', async () => {
      const variantField = document.querySelector(btn.dataset.variantSource || '#variant-id');
      const quantityField = document.querySelector(btn.dataset.quantitySource || '#qty');
      const variantId = variantField?.value;
      const quantity = parseInt(quantityField?.value || quantityField?.textContent || '1', 10);

      if (!variantId) return;

      btn.disabled = true;
      const originalLabel = btn.textContent;
      btn.textContent = 'Processing...';

      try {
        const items = [{ id: variantId, quantity }];
        const standVariantId = getSelectedStandAddonVariantId();
        if (standVariantId) items.push({ id: standVariantId, quantity: 1 });

        await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(items.length === 1 ? items[0] : { items: items.map(item => ({ id: Number(item.id), quantity: item.quantity })) })
        });
        await refreshCartUI();
        window.location.href = '/checkout';
      } catch (_error) {
        btn.disabled = false;
        btn.textContent = originalLabel;
      }
    });
  });

  // Product accordion tabs (legacy pages only — product-page uses initProductTabs)
  document.querySelectorAll('.tab:not([data-tab])').forEach(tab => {
    const header = tab.querySelector('.tab-header');
    if (!header) return;
    header.style.cursor = 'pointer';
    header.addEventListener('click', () => {
      const isOpen = tab.classList.contains('open');
      document.querySelectorAll('.tab').forEach(t => {
        t.classList.remove('open');
        const icon = t.querySelector('.tab-icon');
        if (icon) icon.textContent = '+';
      });
      if (!isOpen) {
        tab.classList.add('open');
        const icon = tab.querySelector('.tab-icon');
        if (icon) icon.textContent = '×';
      }
    });
  });

  // ── SEARCH POPUP ─────────────────────────────────────────────────────────

  let searchDebounceTimer = null;
  let searchAbortController = null;

  function openSearchPopup() {
    if (!searchPopup) return;
    closeMenu();
    closeMobileNavPanel();
    closeDrawers();
    syncGlobalOverlay();
    searchPopup.classList.add('is-open');
    searchPopup.setAttribute('aria-hidden', 'false');
    if (searchTrigger) searchTrigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    setTimeout(() => searchInput?.focus(), 60);
  }

  function closeSearchPopup() {
    if (!searchPopup) return;
    searchPopup.classList.remove('is-open');
    searchPopup.setAttribute('aria-hidden', 'true');
    if (searchTrigger) searchTrigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  function showSearchState(state) {
    // state: 'idle' | 'loading' | 'results' | 'empty'
    if (searchStateidle) searchStateidle.hidden = state !== 'idle';
    if (searchStateLoading) searchStateLoading.hidden = state !== 'loading';
    if (searchStateResults) searchStateResults.hidden = state !== 'results';
    if (searchStateEmpty) searchStateEmpty.hidden = state !== 'empty';
  }

  function formatMoney(cents) {
    if (cents == null) return '';
    const amount = (cents / 100).toFixed(2);
    return `$${amount}`;
  }

  function buildResultItem(item) {
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.className = 'search-result-item';
    a.href = item.url || '#';

    // Image
    if (item.image) {
      const img = document.createElement('img');
      img.className = 'search-result-img';
      // Append query param safely
      const imgUrl = new URL(item.image, window.location.origin);
      imgUrl.searchParams.set('width', '104');
      img.src = imgUrl.toString();
      img.alt = item.title || '';
      img.loading = 'lazy';
      a.appendChild(img);
    } else {
      const placeholder = document.createElement('div');
      placeholder.className = 'search-result-img-placeholder';
      placeholder.textContent = '🎵';
      a.appendChild(placeholder);
    }

    // Info
    const info = document.createElement('div');
    info.className = 'search-result-info';
    const title = document.createElement('p');
    title.className = 'search-result-title';
    title.textContent = item.title || '';
    info.appendChild(title);
    if (item.type || item.product_type) {
      const type = document.createElement('p');
      type.className = 'search-result-type';
      type.textContent = item.type || item.product_type;
      info.appendChild(type);
    }
    a.appendChild(info);

    // Price
    if (item.price != null) {
      const price = document.createElement('span');
      price.className = 'search-result-price';
      // Shopify predictive search returns price as a formatted string or decimal string (e.g. "19.99")
      price.textContent = isNaN(Number(item.price)) ? item.price : `$${Number(item.price).toFixed(2)}`;
      a.appendChild(price);
    }

    li.appendChild(a);
    return li;
  }

  async function runSearch(query) {
    const q = (query || '').trim();
    if (!q) {
      showSearchState('idle');
      if (searchClear) searchClear.hidden = true;
      return;
    }

    if (searchClear) searchClear.hidden = false;
    if (searchViewAll) searchViewAll.href = `/search?q=${encodeURIComponent(q)}`;

    showSearchState('loading');

    // Cancel any in-flight request
    if (searchAbortController) searchAbortController.abort();
    searchAbortController = new AbortController();

    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`;
      const res = await fetch(url, { signal: searchAbortController.signal });
      if (!res.ok) throw new Error('Search failed');
      const data = await res.json();
      const products = data?.resources?.results?.products || [];

      if (products.length === 0) {
        showSearchState('empty');
        return;
      }

      if (searchResultsMeta) {
        searchResultsMeta.textContent = `${products.length} result${products.length !== 1 ? 's' : ''} for "${q}"`;
      }
      if (searchResultsList) {
        searchResultsList.innerHTML = '';
        products.forEach(p => searchResultsList.appendChild(buildResultItem(p)));
      }

      showSearchState('results');
    } catch (err) {
      if (err.name === 'AbortError') return;
      showSearchState('empty');
    }
  }

  function debounceSearch(query) {
    clearTimeout(searchDebounceTimer);
    searchDebounceTimer = setTimeout(() => runSearch(query), 280);
  }

  // Wire up events
  searchTrigger?.addEventListener('click', () => openSearchPopup());

  searchPopupClose?.addEventListener('click', () => closeSearchPopup());
  searchPopupBackdrop?.addEventListener('click', () => closeSearchPopup());

  searchInput?.addEventListener('input', (e) => {
    debounceSearch(e.target.value);
  });

  searchClear?.addEventListener('click', () => {
    if (searchInput) searchInput.value = '';
    if (searchClear) searchClear.hidden = true;
    showSearchState('idle');
    searchInput?.focus();
  });

  searchInput?.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      const q = searchInput.value.trim();
      if (q) window.location.href = `/search?q=${encodeURIComponent(q)}`;
    }
  });

  // Popular search tags
  document.querySelectorAll('.search-tag').forEach(tag => {
    tag.addEventListener('click', () => {
      const q = tag.dataset.query;
      if (!q || !searchInput) return;
      searchInput.value = q;
      if (searchClear) searchClear.hidden = false;
      runSearch(q);
    });
  });

  // Close on Escape is already handled by the global keydown listener above — extend it:
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchPopup?.classList.contains('is-open')) {
      closeSearchPopup();
    }
  });

  // ── END SEARCH POPUP ──────────────────────────────────────────────────────

  initProductTabs();
  initProductFinalCta();
  initVariantIncludes();
  initPartnerLogos();

  // ── END PRODUCT PAGE ────────────────────────────────────────────────────
});

function findVariantIncludesPanel(variantTitle) {
  if (!variantTitle) return null;

  const exact = document.querySelector(
    `.variant-includes-panel[data-variant-includes="${CSS.escape(variantTitle)}"]`
  );
  if (exact) return exact;

  const normalized = variantTitle.trim().toLowerCase();
  return Array.from(document.querySelectorAll('.variant-includes-panel')).find(panel => {
    const key = panel.getAttribute('data-variant-includes');
    return key && key.trim().toLowerCase() === normalized;
  }) || null;
}

function updateVariantIncludes(variantTitle) {
  const includesList = document.getElementById('dynamic-bundle-features');
  if (!includesList || !variantTitle) return;

  const panel = findVariantIncludesPanel(variantTitle);
  if (panel) {
    includesList.innerHTML = panel.innerHTML.trim();
  }
}

function initVariantIncludes() {
  const selected = document.querySelector('.bundle-card.selected');
  if (selected?.dataset.variantTitle) {
    updateVariantIncludes(selected.dataset.variantTitle);
    return;
  }

  const container = document.querySelector('[data-section-type="product-information"]');
  const defaultTitle = container?.dataset.defaultVariantTitle;
  if (defaultTitle) {
    updateVariantIncludes(defaultTitle);
  }
}

function initProductTabs() {
  document.querySelectorAll('[data-product-tabs]').forEach(container => {
    if (container.dataset.tabsBound === 'true') return;
    container.dataset.tabsBound = 'true';

    container.querySelectorAll('[data-tab]').forEach(tab => {
      const header = tab.querySelector('.tab-header');
      if (!header) return;

      header.addEventListener('click', () => {
        const isOpen = tab.classList.contains('open');

        container.querySelectorAll('[data-tab]').forEach(otherTab => {
          otherTab.classList.remove('open');
          const icon = otherTab.querySelector('.tab-icon');
          const btn = otherTab.querySelector('.tab-header');
          if (icon) icon.textContent = '+';
          if (btn) btn.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          tab.classList.add('open');
          const icon = tab.querySelector('.tab-icon');
          if (icon) icon.textContent = '×';
          header.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });
}

function initProductReviewSliders() {
  document.querySelectorAll('[data-review-slider]').forEach(function (root) {
    if (root.dataset.reviewBound === 'true') return;

    const track = root.querySelector('[data-review-track]');
    const viewport = root.querySelector('[data-review-viewport]');
    const prevBtn = root.querySelector('[data-review-prev]');
    const nextBtn = root.querySelector('[data-review-next]');
    const dots = root.querySelectorAll('[data-dot], .review-slider-dot');
    const slides = root.querySelectorAll('.review-slide');
    if (!track || slides.length === 0) return;

    root.dataset.reviewBound = 'true';

    let index = 0;
    const n = slides.length;
    let touchStartX = 0;

    root.style.setProperty('--review-slides', String(n));

    function setSlide(i) {
      index = ((i % n) + n) % n;
      const pct = (100 * index) / n;
      track.style.transform = 'translateX(-' + pct + '%)';
      slides.forEach(function (slide, j) {
        slide.setAttribute('aria-hidden', j === index ? 'false' : 'true');
      });
      dots.forEach(function (dot, j) {
        const on = j === index;
        dot.classList.toggle('is-active', on);
        if (on) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    function step(delta) {
      setSlide(index + delta);
    }

    prevBtn?.addEventListener('click', function () {
      step(-1);
    });
    nextBtn?.addEventListener('click', function () {
      step(1);
    });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        const j = parseInt(dot.getAttribute('data-dot'), 10);
        if (!isNaN(j)) setSlide(j);
      });
    });

    viewport?.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        step(-1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        step(1);
      }
    });

    viewport?.addEventListener(
      'touchstart',
      function (e) {
        touchStartX = e.changedTouches[0].clientX;
      },
      { passive: true }
    );
    viewport?.addEventListener(
      'touchend',
      function (e) {
        const dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) < 48) return;
        if (dx > 0) step(-1);
        else step(1);
      },
      { passive: true }
    );

    setSlide(0);
  });
}

function initProductReviewForm() {
  document.querySelectorAll('[data-product-review-form]').forEach(function (root) {
    if (root.dataset.reviewFormBound === 'true') return;

    const canReview = root.dataset.canReview === 'true';
    const productId = root.dataset.productId;
    const storageKey = productId ? 'mdt_review_submitted_' + productId : '';
    const form = root.querySelector('[data-product-review-submit]');
    const feedback = root.querySelector('[data-review-feedback]');
    const ratingInput = root.querySelector('#product-review-rating');
    const starButtons = root.querySelectorAll('[data-review-star]');

    root.dataset.reviewFormBound = 'true';

    if (storageKey && localStorage.getItem(storageKey) === '1' && form) {
      form.remove();
      const note = document.createElement('p');
      note.className = 'product-review-form-note product-review-form-note--success';
      note.textContent =
        root.dataset.alreadyMessage ||
        'Thank you — your review has been submitted and will appear after it is approved.';
      root.appendChild(note);
      return;
    }

    if (!form || !canReview) return;

    function setRating(value) {
      const rating = Math.min(5, Math.max(1, Number(value) || 5));
      if (ratingInput) ratingInput.value = String(rating);
      starButtons.forEach(function (btn) {
        const starValue = Number(btn.dataset.reviewStar);
        btn.classList.toggle('is-active', starValue <= rating);
        btn.setAttribute('aria-pressed', starValue <= rating ? 'true' : 'false');
      });
    }

    setRating(ratingInput?.value || 5);

    starButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setRating(btn.dataset.reviewStar);
      });
    });

    form.addEventListener('submit', async function (event) {
      event.preventDefault();

      if (root.dataset.canReview !== 'true') {
        if (feedback) {
          feedback.hidden = false;
          feedback.className = 'product-review-form-feedback is-error';
          feedback.textContent = 'Only signed-in verified buyers can submit a review for this product.';
        }
        return;
      }

      const bodyField = form.querySelector('#product-review-body');
      const body = bodyField?.value.trim() || '';
      const rating = ratingInput?.value || '5';
      const email = root.dataset.customerEmail || '';
      const name = root.dataset.customerName || email.split('@')[0] || 'Customer';
      const productTitle = root.dataset.productTitle || 'Product';

      if (!email) {
        if (feedback) {
          feedback.hidden = false;
          feedback.className = 'product-review-form-feedback is-error';
          feedback.textContent = 'Please sign in with the account you used to purchase this product.';
        }
        return;
      }

      if (body.length < 20) {
        if (feedback) {
          feedback.hidden = false;
          feedback.className = 'product-review-form-feedback is-error';
          feedback.textContent = 'Please write at least 20 characters in your review.';
        }
        bodyField?.focus();
        return;
      }

      const submitBtn = form.querySelector('.product-review-submit-btn');
      const originalLabel = submitBtn?.textContent || 'Submit review';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting...';
      }
      if (feedback) feedback.hidden = true;

      const message = [
        '[PRODUCT REVIEW — verified buyer]',
        'Product: ' + productTitle,
        'Product ID: ' + (productId || ''),
        'Rating: ' + rating + '/5',
        'Customer: ' + name + ' <' + email + '>',
        '',
        body
      ].join('\n');

      const payload = new FormData();
      payload.append('form_type', 'contact');
      payload.append('utf8', '✓');
      payload.append('contact[name]', name);
      payload.append('contact[email]', email);
      payload.append('contact[body]', message);

      try {
        const response = await fetch('/contact', {
          method: 'POST',
          body: payload,
          headers: { Accept: 'text/html' },
          credentials: 'same-origin'
        });

        if (!response.ok && !response.redirected) {
          throw new Error('submit_failed');
        }

        if (storageKey) localStorage.setItem(storageKey, '1');

        form.remove();
        const success = document.createElement('p');
        success.className = 'product-review-form-note product-review-form-note--success';
        success.textContent =
          root.dataset.successMessage ||
          'Thank you! Your review was sent for approval and will appear here once verified.';
        root.appendChild(success);
      } catch (_error) {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalLabel;
        }
        if (feedback) {
          feedback.hidden = false;
          feedback.className = 'product-review-form-feedback is-error';
          feedback.textContent = 'Could not submit your review. Please try again or contact support.';
        }
      }
    });
  });
}

function initProductFinalCta() {
  document.querySelectorAll('[data-scroll-to-cart]').forEach(btn => {
    if (btn.dataset.ctaBound === 'true') return;
    btn.dataset.ctaBound = 'true';
    btn.addEventListener('click', () => {
      const target = document.getElementById('add-to-cart-btn') || document.getElementById('qty');
      target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
}


const productGalleryPreloadCache = new Map();

function preloadProductGalleryImage(url) {
  if (!url) return Promise.resolve(null);
  const cached = productGalleryPreloadCache.get(url);
  if (cached && cached.complete) return Promise.resolve(cached);

  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      productGalleryPreloadCache.set(url, img);
      resolve(img);
    };
    img.onerror = reject;
    img.src = url;
  });
}

function preloadProductGalleryFromStrip(gallery) {
  if (!gallery) return;
  gallery.querySelectorAll('.thumb[data-image-url]').forEach(thumb => {
    preloadProductGalleryImage(thumb.getAttribute('data-image-url')).catch(() => {});
  });
}

function setMainProductImage(mainImg, imgUrl, imgAlt) {
  if (!mainImg || !imgUrl) return;

  if (mainImg.src !== imgUrl) {
    mainImg.src = imgUrl;
    mainImg.removeAttribute('srcset');
    mainImg.removeAttribute('sizes');
  }
  if (imgAlt) mainImg.alt = imgAlt;
  mainImg.style.display = '';
  mainImg.hidden = false;
}

function pauseProductGalleryVideos() {
  document.querySelectorAll('[data-gallery-video-view] video').forEach(function (video) {
    video.pause();
  });
}

function showProductGalleryVideo(mediaId) {
  const videoView = document.querySelector('[data-gallery-video-view]');
  const imageView = document.querySelector('[data-gallery-image-view]');
  if (!videoView || !mediaId) return;

  pauseProductGalleryVideos();

  if (imageView) imageView.hidden = true;
  videoView.hidden = false;

  let activePanel = null;
  videoView.querySelectorAll('[data-video-panel]').forEach(function (panel) {
    const isActive = panel.getAttribute('data-video-panel') === String(mediaId);
    panel.hidden = !isActive;
    if (isActive) activePanel = panel;
  });

  const video = activePanel?.querySelector('video');
  if (video) {
    video.currentTime = 0;
    video.play().catch(function () {});
  }
}

function showProductGalleryImage(mainImg, imgUrl, imgAlt) {
  const videoView = document.querySelector('[data-gallery-video-view]');
  const imageView = document.querySelector('[data-gallery-image-view]');
  if (!imageView) return;

  pauseProductGalleryVideos();
  if (videoView) {
    videoView.hidden = true;
    videoView.querySelectorAll('[data-video-panel]').forEach(function (panel) {
      panel.hidden = true;
    });
  }
  imageView.hidden = false;

  if (mainImg && imgUrl) {
    setMainProductImage(mainImg, imgUrl, imgAlt);
  }
}

function initProductGallery() {
  const gallery = document.querySelector('[data-section-type="product-information"] .thumbnail-strip');
  if (!gallery || gallery.dataset.galleryBound === 'true') return;

  const mainImg = document.getElementById('main-product-img');

  gallery.dataset.galleryBound = 'true';
  preloadProductGalleryFromStrip(gallery);

  gallery.addEventListener('pointerenter', event => {
    const thumb = event.target.closest('.thumb');
    if (!thumb || !gallery.contains(thumb)) return;
    preloadProductGalleryImage(thumb.getAttribute('data-image-url')).catch(() => {});
  }, true);

  gallery.addEventListener('click', event => {
    const thumb = event.target.closest('.thumb');
    if (!thumb || !gallery.contains(thumb)) return;

    const mediaType = thumb.getAttribute('data-media-type') || 'image';
    const mediaId = thumb.getAttribute('data-media-id');
    const imgUrl = thumb.getAttribute('data-image-url');
    const imgAlt = thumb.getAttribute('data-image-alt');

    gallery.querySelectorAll('.thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');

    if (mediaType === 'video' || mediaType === 'external_video') {
      showProductGalleryVideo(mediaId);
      return;
    }

    showProductGalleryImage(mainImg, imgUrl, imgAlt);
  });
}

function initResearchBridge() {
  document.querySelectorAll('[data-bridge-root]').forEach(root => {
    if (root.dataset.bridgeBound === 'true') return;
    root.dataset.bridgeBound = 'true';

    const tabs = Array.from(root.querySelectorAll('.bridge-tab[role="tab"]'));
    const panels = Array.from(root.querySelectorAll('.bridge-panel[data-bridge-theme]'));
    const tablist = root.querySelector('[role="tablist"]');
    if (!tabs.length) return;

    function showTheme(theme) {
      tabs.forEach(tab => {
        const on = tab.getAttribute('data-bridge-theme') === theme;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
      });
      panels.forEach(panel => {
        panel.classList.toggle('is-active', panel.getAttribute('data-bridge-theme') === theme);
      });
    }

    tabs.forEach(tab => {
      tab.addEventListener('click', () => showTheme(tab.getAttribute('data-bridge-theme')));
    });

    tablist?.addEventListener('keydown', event => {
      if (!['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].includes(event.key)) return;
      event.preventDefault();
      const activeIndex = tabs.indexOf(document.activeElement);
      if (activeIndex === -1) return;
      const nextIndex =
        event.key === 'ArrowRight' || event.key === 'ArrowDown'
          ? (activeIndex + 1) % tabs.length
          : (activeIndex - 1 + tabs.length) % tabs.length;
      const nextTab = tabs[nextIndex];
      showTheme(nextTab.getAttribute('data-bridge-theme'));
      nextTab.focus();
    });

    document.querySelectorAll('.rp-bio-card--interactive[data-bridge-theme]').forEach(card => {
      if (card.dataset.bridgeCardBound === 'true') return;
      card.dataset.bridgeCardBound = 'true';

      function activateCard() {
        const theme = card.getAttribute('data-bridge-theme');
        showTheme(theme);
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        tabs.find(tab => tab.getAttribute('data-bridge-theme') === theme)?.focus();
      }

      card.addEventListener('click', activateCard);
      card.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          activateCard();
        }
      });
    });

    const initialTab = tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || tabs[0];
    showTheme(initialTab.getAttribute('data-bridge-theme'));
  });
}

function resetResearchBridgeBindings() {
  document.querySelectorAll('[data-bridge-root]').forEach(root => {
    delete root.dataset.bridgeBound;
  });
  document.querySelectorAll('.rp-bio-card--interactive[data-bridge-theme]').forEach(card => {
    delete card.dataset.bridgeCardBound;
  });
}

function initVideoTestimonials() {
  const viewport = document.getElementById('video-testimonials-viewport');
  const prevBtn = document.getElementById('video-testimonials-prev');
  const nextBtn = document.getElementById('video-testimonials-next');
  const dotsRoot = document.getElementById('video-testimonials-dots');
  if (!viewport || !prevBtn || !nextBtn || !dotsRoot || viewport.dataset.carouselBound === 'true') return;

  const slides = Array.from(viewport.querySelectorAll('.video-testimonial'));
  if (slides.length === 0) return;

  viewport.dataset.carouselBound = 'true';
  dotsRoot.innerHTML = '';

  slides.forEach((_, index) => {
    const dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'video-testimonials-dot';
    dot.setAttribute('aria-label', `Testimonial ${index + 1} of ${slides.length}`);
    dot.addEventListener('click', () => goTo(index));
    dotsRoot.appendChild(dot);
  });

  const dots = Array.from(dotsRoot.querySelectorAll('.video-testimonials-dot'));

  function slideWidth() {
    return viewport.clientWidth;
  }

  function currentIndex() {
    const width = slideWidth();
    return width <= 0 ? 0 : Math.round(viewport.scrollLeft / width);
  }

  function goTo(index) {
    const width = slideWidth();
    const clamped = Math.max(0, Math.min(slides.length - 1, index));
    viewport.scrollTo({ left: clamped * width, behavior: 'smooth' });
  }

  function syncUi() {
    const index = currentIndex();
    prevBtn.disabled = index <= 0;
    nextBtn.disabled = index >= slides.length - 1;
    dots.forEach((dot, dotIndex) => {
      dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
    });
  }

  let scrollEndTimer;
  viewport.addEventListener('scroll', () => {
    syncUi();
    clearTimeout(scrollEndTimer);
    scrollEndTimer = setTimeout(syncUi, 80);
  });

  prevBtn.addEventListener('click', () => goTo(currentIndex() - 1));
  nextBtn.addEventListener('click', () => goTo(currentIndex() + 1));

  viewport.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      goTo(currentIndex() - 1);
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      goTo(currentIndex() + 1);
    }
  });

  window.addEventListener(
    'resize',
    () => {
      const index = currentIndex();
      viewport.scrollLeft = index * slideWidth();
      syncUi();
    },
    { passive: true }
  );

  syncUi();
}

function resetVideoTestimonialsBindings() {
  const viewport = document.getElementById('video-testimonials-viewport');
  if (!viewport) return;
  delete viewport.dataset.carouselBound;
  const dotsRoot = document.getElementById('video-testimonials-dots');
  if (dotsRoot) dotsRoot.innerHTML = '';
}

function initPartnerLogos() {
  const section = document.querySelector('.partners-section');
  if (!section || section.dataset.logosBound === 'true') return;

  const partners = [
    { name: 'International Association of Sound Massage Therapy', file: 'partner-iasmt.png' },
    { name: 'Thyrocare Laboratory', file: 'partner-thyrocare.webp' },
    { name: 'Hess Sound', file: 'partner-hess-sound.webp' },
    { name: 'Peter Hess Academy', file: 'partner-hess-sound.webp' },
    { name: 'Manan Wellbeing LLP', file: 'partner-manan-wellness.webp' }
  ];

  const logoSrc = document.querySelector('img[src*="/assets/naadveda-logo"]')?.src;
  const assetBase = logoSrc ? logoSrc.replace(/naadveda-logo\.[^/?]+(\?.*)?$/, '') : null;
  if (!assetBase) return;

  let updated = false;
  section.querySelectorAll('.partner-card').forEach((card, index) => {
    if (card.querySelector('.partner-card__logo')) return;

    const nameEl = card.querySelector('.partner-card__name');
    const partnerName = nameEl?.textContent?.trim() || partners[index]?.name;
    const partner = partners.find(item => item.name === partnerName) || partners[index];
    if (!partner) return;

    const img = document.createElement('img');
    img.className = 'partner-card__logo';
    img.loading = 'lazy';
    img.alt = partner.name;
    img.width = 280;
    img.height = 80;
    img.src = assetBase + partner.file;

    if (nameEl) nameEl.replaceWith(img);
    else card.appendChild(img);
    updated = true;
  });

  if (updated) section.dataset.logosBound = 'true';
}

function initTrackOrderForm() {
  const form = document.getElementById('track-order-form');
  const message = document.getElementById('track-demo-msg');
  if (!form || !message || form.dataset.trackBound === 'true') return;

  form.dataset.trackBound = 'true';
  form.addEventListener('submit', event => {
    event.preventDefault();
    message.hidden = false;
    message.textContent =
      message.dataset.demoMessage ||
      'In a live Shopify theme, connect this form to your order-status app, Storefront API, or Flow. Customers can also use the order status link in their confirmation email, or sign in at /account to see all orders.';
  });
}

function resetTrackOrderBindings() {
  const form = document.getElementById('track-order-form');
  if (form) delete form.dataset.trackBound;
}

// Re-bind product gallery only when the theme editor reloads a section
document.addEventListener('shopify:section:load', function () {
  const strip = document.querySelector('[data-section-type="product-information"] .thumbnail-strip');
  if (strip) delete strip.dataset.galleryBound;
  document.querySelectorAll('[data-review-slider]').forEach(function (root) {
    delete root.dataset.reviewBound;
  });
  document.querySelectorAll('[data-product-review-form]').forEach(function (root) {
    delete root.dataset.reviewFormBound;
  });
  initProductGallery();
  initProductTabs();
  initProductFinalCta();
  initProductReviewSliders();
  initProductReviewForm();
  initVariantIncludes();
  resetResearchBridgeBindings();
  initResearchBridge();
  resetVideoTestimonialsBindings();
  initVideoTestimonials();
  resetTrackOrderBindings();
  initTrackOrderForm();
  const partnersSection = document.querySelector('.partners-section');
  if (partnersSection) delete partnersSection.dataset.logosBound;
  initPartnerLogos();
});
